module.exports = __webpack_public_path__ + "static/media/b3.ee37307a.jpg";